import { postData } from "./cors";

export async function login(u, p) {
  let data = {
    username: u,
    password: p
  };
  try {
    let response = await fetch("/api/login.php", postData(data));
    let responseJson = await response.json();
    if (responseJson.error) {
      return responseJson;
    } else {
      document.location.href = "/panel/";
    }
  } catch (e) {
    return e;
  }
}

export async function register(data) {
  try {
    let response = await fetch("/api/register.php", postData(data));
    let responseJson = await response.json();
    if (responseJson.error) {
      return responseJson;
    } else {
      document.location.href = "/panel/";
    }
  } catch (e) {
    return e;
  }
}
